import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-z-short',
  templateUrl: './z-short.component.html',
  styleUrls: ['./z-short.component.scss']
})
export class ZShortComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
